import React, {useRef, useEffect} from 'react';
import TextField from '@mui/material/TextField';
import {Box} from '@mui/material';

interface WordLimit {
  enforceWordLimit: boolean;
  EnforcedCount: number;
}

type ContextFields = {
  question: any;
  value: string; // Parent controls the value
  onAnswerChange: (questionId: number, value: string) => void;
  setErrors?: (value: boolean) => void;
};

const ContextTextField: React.FC<ContextFields> = ({
  question,
  value,
  onAnswerChange,
  setErrors
}) => {
  //console.log('value', value);
  const [values, setValue] = React.useState(value);
  const inputRef = useRef<HTMLTextAreaElement>(null);
  const wordLimit: WordLimit = {
    enforceWordLimit: question?.descriptive_enforce_word_limit
      ? JSON.parse(question?.descriptive_enforce_word_limit)
          .descriptive_enforce_word_limit
      : false,
    EnforcedCount: question?.descriptive_enforce_word_limit_length
      ? parseInt(
          JSON.parse(question?.descriptive_enforce_word_limit_length)
            .descriptive_enforce_word_limit_length
        )
      : 0
  };
//   useEffect(() => {
//     setValue(value);
//   }, []);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      //console.log('values', values,inputRef);
      if (
        inputRef.current &&
        !inputRef.current.contains(event.target as Node)
      ) {
        if (
          !wordLimit.enforceWordLimit ||
          values.split(/\s+/).length <= wordLimit.EnforcedCount
        ) {
          //console.log('values',(inputRef.current as HTMLTextAreaElement).value, values);
          onAnswerChange(question.id, (inputRef.current as HTMLTextAreaElement).value);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [value]);

  //   const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //     const inputValue = e.target.value;
  //     const wordCount = inputValue.trim().split(/\s+/).length;

  //     onAnswerChange(question.id, inputValue);
  //   };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const wordCount = inputValue.trim().split(/\s+/).length;
    //console.log('enterss', wordCount, inputValue);
    if (wordLimit.enforceWordLimit && wordCount > wordLimit.EnforcedCount) {
      setErrors?.(true);
    } else {
      setErrors?.(false);
    }
    setValue(inputValue);
  };

  return (
    <Box>
      <TextField
        key={question.id}
        inputRef={inputRef}
        label="Enter text"
        variant="outlined"
        multiline
        value={values}
        onChange={handleChange}
        fullWidth
        error={
          wordLimit.enforceWordLimit &&
          values.split(/\s+/).length > wordLimit.EnforcedCount
        }
        helperText={
          wordLimit.enforceWordLimit &&
          values.split(/\s+/).length > wordLimit.EnforcedCount
            ? `Word limit exceeded. Max ${wordLimit.EnforcedCount} words allowed.`
            : ''
        }
        InputProps={{
          sx: {
            typography: 'body2',
            minHeight: '12vh',
            alignItems: 'baseline'
          }
        }}
        sx={{minHeight: '12vh', mt: 1}}
      />
    </Box>
  );
};

export default ContextTextField;
